import PropTypes from 'prop-types'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const verticalMenuProps = {
  MenuListProps: {
    sx: {
      '&&': {
        alignItems: 'stretch',
        display: 'flex',
        flexDirection: 'column',
      },
    },
  },
}

const menuItemSx = {
  '&&': {
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'flex-start',
    width: '100%',
  },
}

const VerticalSingleSelectEditCell = ({
  api,
  colDef,
  field,
  id,
  row,
  value,
}) => {
  const valueOptions = typeof colDef.valueOptions === 'function'
    ? colDef.valueOptions({ field, id, row })
    : colDef.valueOptions || []

  const handleChange = (event) => {
    api.setEditCellValue(
      { field, id, value: event.target.value },
      event
    )
  }

  return (
    <Select
      fullWidth
      MenuProps={verticalMenuProps}
      onChange={handleChange}
      value={value ?? ''}
    >
      {valueOptions.map((option) => {
        const isObjectOption = typeof option === 'object'
        const optionValue = isObjectOption ? option.value : option
        const optionLabel = isObjectOption ? option.label : option

        return (
          <MenuItem
            key={optionValue}
            sx={menuItemSx}
            value={optionValue}
          >
            {optionLabel}
          </MenuItem>
        )
      })}
    </Select>
  )
}

VerticalSingleSelectEditCell.propTypes = {
  api: PropTypes.shape({
    setEditCellValue: PropTypes.func.isRequired,
  }).isRequired,
  colDef: PropTypes.shape({
    valueOptions: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.func,
    ]),
  }).isRequired,
  field: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  row: PropTypes.object,
  value: PropTypes.any,
}

export default VerticalSingleSelectEditCell
